

export const GET_PRODUCT_SUCCESS = 'getProductSuccess';

export const GET_PRODUCT_FAIL = 'getProductFail';

export const GET_PRODUCT_DETAILS_REQUEST = 'getProductDetailsRequest';

export const GET_PRODUCT_DETAILS_SUCCESS = 'getProductDetailsSuccess';

export const GET_PRODUCT_DETAILS_FAIL = 'getProductDetailsFail';

export const GET_PRODUCT_DETAILS_RESET = 'getProductDetailsReset';

